/**
 * Generated runtime TestId mirror for frontend/src/pages/Connectors.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

export const ConnectorsTestIds = {
  connectorsWelcomeCard: "connectors-welcome-card"
} as const;
